import { View } from "binder"
import { ToolModelFromProducerManipulationViewModel, ToolModelFromProducer } from "./toolModelFromProducerManipulation-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";

export class ToolModelFromProducerManipulationView extends View<ToolModelFromProducerManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-65FE7599-64D7-47A3-A4D8-8B254A0A627E"
    }
    loadHtml(): string {
        let element = require('./toolModelFromProducerManipulation.html').default;
        let style = require('./toolModelFromProducerManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set toolModelFromProducers(v: ToolModelFromProducer) { this._toolModelFromProducers = v; } public get toolModelFromProducers(): ToolModelFromProducer { return this._toolModelFromProducers; } private _toolModelFromProducers: ToolModelFromProducer;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    addNew() {
        this.dataContext.addNew();
    }
}
